import axios from "axios";
import { API } from "../common/Constants";
const accessToken = localStorage.getItem("agentModuleToken");

export const apiAxios = axios.create({
    // baseURL:'https://api.ohhto.com/v1/',
    baseURL:API.serverUrl,
})

export default axios.create({
    baseURL:`${API.BaseUrl}`,
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
})